function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#00267f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5h10v20h-10V5Z",
    style: {
      fill: "#ffc726"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15,10.155c-.325.886-.656,1.809-1.365,2.515.22-.073.605-.138.852-.131v3.727l-1.052.156c-.038-.004-.05-.062-.05-.142-.101-1.158-.375-2.13-.69-3.136-.023-.138-.421-.662-.114-.57.037.005.449.173.384.093-.56-.58-1.379-.997-2.174-1.121-.07-.017-.111.018-.049.099,1.055,1.624,1.938,3.54,1.93,5.814.41,0,1.404-.242,1.815-.242v2.63h.519l.119-7.345-.125-2.347Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M15,10.155c.325.886.656,1.809,1.365,2.515-.22-.073-.605-.138-.852-.131v3.727l1.053.156c.038-.004.05-.062.05-.142.101-1.158.375-2.13.69-3.136.022-.138.421-.662.114-.57-.038.005-.449.173-.384.093.56-.58,1.379-.997,2.174-1.121.07-.017.111.018.049.099-1.055,1.624-1.938,3.54-1.93,5.814-.41,0-1.404-.242-1.815-.242v2.63h-.519l-.119-7.345.124-2.347Z",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/BB.5f0b710e1c9b82ed7aac52d0a4c38ad0.svg";
export { ForwardRef as ReactComponent };